import { HandlerWithResult, replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, PopulateApiParameter , SendDataToApi} from "@insite/client-framework/Store/Components/ContactUsForm/Handlers/SubmitContactForm";

import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { submitContactUsForm, SubmitContactUsFormApiParameter } from "@tFissco/Services/CustomEmailService";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

interface SubmitContactUsFormExtendedApiParameter extends SubmitContactUsFormApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    company?: string;
    phoneNumber?: string;
    emailAddress?: string;
    comments?: string;
    emailTo?: string;
    methodOfContact?: string;
    country?: string;
} 

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormExtendedApiParameter>;

export const CustomPopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;
    props.apiParameter = {
        topic: state.fieldValues["topic"],
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        company: state.fieldValues["company"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        comments: state.fieldValues["comments"],
        methodOfContact: state.fieldValues["methodOfContact"],
        emailTo: props.parameter.emailRecipients,
        country: state.fieldValues["country"],
    };
};

export const CustomSendDataToApi: HandlerType = async props => {
    await submitContactUsForm(props.apiParameter);
};

replaceInChain(chain, PopulateApiParameter, CustomPopulateApiParameter);

replaceInChain(chain, SendDataToApi, CustomSendDataToApi);
